module.exports = __webpack_public_path__ + "img/your_kisuma.4b77212c.jpg";